module.exports = __webpack_public_path__ + "static/media/CAM_H_05.7b2fe305.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/faces/CAM_H_05.png
// module id = 156
// module chunks = 0